import { State, Validation } from './types';

const expression =
  // eslint-disable-next-line
  /^(:?https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/?.*)?|^((:?https:\/\/)?([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])?(\/?.*)$/;
const urlRe = new RegExp(expression, 'i');
const ipCidrRegex =
  /^(?:(?:\d{1,3}\.){3}\d{1,3}(?:\/(?:[0-9]|[12][0-9]|3[0-2]))?|(?:[A-Fa-f0-9:]+)(?:\/(?:[0-9]|1[0-1][0-9]|12[0-8]))?)$/;
const ipRe = new RegExp(ipCidrRegex, 'i');

export const onValidateTargetSystem = (state: State) => {
  const {
    name,
    location,
    selectedAuthType,
    format,
    organization,
    grantType,
    allowIP,
  } = state;
  state.validation = {
    ...state.validation,
    name: name.length > 0,
    organization: organization.length > 0,
    grantType: grantType.length > 0,
    location:
      location.length > 10 &&
      location.indexOf('.') !== -1 &&
      urlRe.test(location),
    selectedAuthType: !!selectedAuthType,
    format: !!format,
    allowIP: !!allowIP && (allowIP.length === 0 || ipRe.test(allowIP)),
  };
  const valid = state.validation;
  state.valid =
    state.valid &&
    valid.name &&
    valid.location &&
    valid.format &&
    valid.selectedAuthType;
};

export const onValidateApiKey = (state: State) => {
  const { key, updateKey } = state;

  state.validation = {
    ...state.validation,
    key: updateKey === false || key.length >= 32,
  };

  const valid = state.validation;
  state.valid = valid.key;

  onValidateTargetSystem(state);
};

export const onValidateOauth = (state: State) => {
  const { username, password, authEndpoint, updateKey, redirectURI, code } =
    state;

  state.validation = {
    ...state.validation,
    username: username.length > 0,
    password:
      (password.length > 0 && updateKey === true) || updateKey === false,
    authEndpoint: authEndpoint.length > 10 && urlRe.test(authEndpoint),
    code:
      state.grantType !== 'authorization_code' ||
      (code ? code.length > 0 : false),
    redirectURI:
      state.grantType !== 'authorization_code' ||
      (redirectURI ? urlRe.test(redirectURI) : true),
  };

  const valid = state.validation;
  state.valid =
    valid.username &&
    valid.password &&
    valid.authEndpoint &&
    valid.code &&
    valid.redirectURI;

  onValidateTargetSystem(state);
};

export const onValidateBasicOrDigest = (state: State) => {
  const { username, password, updateKey } = state;

  state.validation = {
    ...state.validation,
    username: username.length > 0,
    password: password.length > 0,
  };

  const valid = state.validation;
  if (updateKey) {
    state.valid = valid.username && valid.password;
  } else {
    state.valid = valid.username;
  }

  onValidateTargetSystem(state);
};

export const onValidateTLS = (state: State) => {
  state.valid = !!state.legacy;

  onValidateTargetSystem(state);
};

export const onValidateHMACSHA256 = (state: State) => {
  state.valid = true;
  onValidateTargetSystem(state);
};

type ValidationKey = keyof Validation;
export const isInvalid = (key: ValidationKey, state: State) => {
  return state.messages && !state.validation[key];
};
